module.exports = __webpack_public_path__ + "static/img/page14.0982797.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/page14.jpg
// module id = psy3
// module chunks = 0